import * as React from "react";
import PropTypes from "prop-types";
import SpComparison from "../UI/SpComparison";
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";

const styles = (theme) => ({
  portfolioNumbers: {
    width: "100%",
    marginTop: 20,
    marginBottom: 20,
    display: "flex",
    flexDirection: "row",
    breakInside: "avoid", // Print style
    alignItems: "center",
  },
});

const CyComparison = (props) => {
  const {
    classes,
    summaryData,
    finalWealth,
    riskPeriod,
    finalWealthWithAnnualWithdrawal,
  } = props;
  return (
    <Grid container={true} className={classes.portfolioNumbers}>
      {riskPeriod === "worst.4q" && (
        <Grid item={true} xs={6} md={3}>
          <SpComparison
            label={
              summaryData.benchmark.Worst4QtrReturn -
                summaryData.recommendationSummary.Worst4QtrReturn <=
              0
                ? "Less Risk"
                : "More Risk"
            }
            data={{
              type: "percentage",
              value:
                summaryData.benchmark.Worst4QtrReturn -
                summaryData.recommendationSummary.Worst4QtrReturn,
            }}
            showSign={true}
            subscript={`vs. ${summaryData.benchmark.Name}`}
          />
        </Grid>
      )}
      {riskPeriod === "worst.calendar.year" && (
        <Grid item={true} xs={6} md={3}>
          <SpComparison
            label={
              summaryData.benchmark.WorstCalendarYearReturn -
                summaryData.recommendationSummary.WorstCalendarYearReturn <=
              0
                ? "Less Risk"
                : "More Risk"
            }
            data={{
              type: "percentage",
              value:
                summaryData.benchmark.WorstCalendarYearReturn -
                summaryData.recommendationSummary.WorstCalendarYearReturn,
            }}
            showSign={true}
            subscript={`vs. ${summaryData.benchmark.Name}`}
          />
        </Grid>
      )}
      {riskPeriod === "mdd" && (
        <Grid item={true} xs={6} md={3}>
          <SpComparison
            label={
              summaryData.benchmark.MaxDrawdown -
                summaryData.recommendationSummary.MaxDrawdown <=
              0
                ? "Less Risk"
                : "More Risk"
            }
            data={{
              type: "percentage",
              value:
                summaryData.benchmark.MaxDrawdown -
                summaryData.recommendationSummary.MaxDrawdown,
            }}
            showSign={true}
            subscript={`vs. ${summaryData.benchmark.Name}`}
          />
        </Grid>
      )}

      <Grid item={true} xs={6} md={3}>
        <SpComparison
          label={
            summaryData.recommendationSummary.AnnualizedReturn -
              summaryData.benchmark.AnnualizedReturn >=
            0
              ? "More Return"
              : "Less Return"
          }
          data={{
            type: "percentage",
            value:
              summaryData.recommendationSummary.AnnualizedReturn -
              summaryData.benchmark.AnnualizedReturn,
          }}
          showSign={true}
          subscript={`vs. ${summaryData.benchmark.Name}`}
        />
      </Grid>

      <Grid item={true} xs={6} md={3}>
        <SpComparison
          label={
            finalWealth["Cy"] - finalWealth["Benchmark"] >= 0
              ? "More Capital"
              : "Less Capital"
          }
          data={{
            type: "currency",
            value: finalWealth["Cy"] - finalWealth["Benchmark"],
          }}
          showSign={true}
          subscript={`vs. ${summaryData.benchmark.Name}`}
        />
      </Grid>

      {finalWealthWithAnnualWithdrawal && (
        <Grid item={true} xs={6} md={3}>
          <SpComparison
            label={
              finalWealthWithAnnualWithdrawal["Cy"] -
                finalWealthWithAnnualWithdrawal["Benchmark"] >=
              0
                ? "More Capital with Annual Withdrawal"
                : "Less Capital with Annual Withdrawal"
            }
            data={{
              type: "currency",
              value:
                finalWealthWithAnnualWithdrawal["Cy"] -
                finalWealthWithAnnualWithdrawal["Benchmark"],
            }}
            showSign={true}
            subscript={`vs. ${summaryData.benchmark.Name}`}
          />
        </Grid>
      )}
      {
        // !finalWealthWithAnnualWithdrawal && remainingBalance && remainingBalance.remainingWealth &&
        // <Grid item={true} xs={6} md={3}>
        //   <SpComparison label={"Remaining Wealth"}
        //                 data={{type: "currency", value: remainingBalance.remainingWealth > 0 ? remainingBalance.remainingWealth : 0 }} showSign={false}
        //                 subscript={`with ${(remainingBalance.knownReturn * 100).toFixed(2)}% return`}
        //   />
        // </Grid>
      }
    </Grid>
  );
};

CyComparison.propTypes = {
  classes: PropTypes.object,
  summaryData: PropTypes.shape({
    benchmark: PropTypes.object.isRequired,
    recommendationSummary: PropTypes.object.isRequired,
  }),
  finalWealth: PropTypes.shape({
    Cy: PropTypes.number.isRequired,
    Benchmark: PropTypes.number.isRequired,
  }),
  finalWealthWithAnnualWithdrawal: PropTypes.shape({
    Cy: PropTypes.number.isRequired,
    Benchmark: PropTypes.number.isRequired,
  }),
  riskPeriod: PropTypes.string.isRequired,
};

export default withStyles(styles)(CyComparison);



// WEBPACK FOOTER //
// ./src/components/Charts/CyComparison.jsx